import type { Nullable } from './util';

export enum Direction {
  Target = 'target',
  Source = 'source',
}

export enum Realm {
  LOGIN = 'LOGIN',
  TEST = 'TEST',
}

export interface Connection {
  username: string;
  domain: string;
  realm: Realm;
  config: {
    enableAdvancedApprovals: boolean;
    enableBilling: boolean;
    migrationIssuesV25: boolean;
  };
  trialEndTime: Nullable<string>;
}
